import React from 'react';
import './Productions.css';

const Productions = ({ services }) => (
  <section className="prod"><div className="prod__container">{services.map(({ title, img, text, link, linkLabel }, idx) => (
    <React.Fragment key={title}>
      <div className="prod__card"><div className="prod__image-wrapper"><img src={img} alt={title} loading="lazy" className="prod__image" /><div className="prod__image-overlay"></div></div><div className="prod__content"><h3 className="prod__title">{title}</h3><p className="prod__text">{text}</p><a className="prod__btn" href={link}><span>{linkLabel || `Explore ${title} Services`}</span><svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></a></div></div>
      {idx < services.length - 1 && <div className="prod__divider"></div>}
    </React.Fragment>
  ))}</div></section>
);

export default Productions;

